module.exports = __webpack_public_path__ + "img/jdb.c0a65c80.png";